"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataUsage = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/styles");
var _pittaModules = require("@thingsw/pitta-modules");
var _ = require("..");
var _clsx = _interopRequireDefault(require("clsx"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Webviewer = {
  mobile: 760
};
var useStyle = (0, _styles.makeStyles)(function (theme) {
  return {
    body: _defineProperty({
      display: "flex",
      alignItems: "center"
    }, theme.breakpoints.up(Webviewer.mobile), {}),
    root: {
      position: "relative"
    },
    circleBottom: {
      color: _pittaModules.LightColors.secondary["19"]
    },
    circleTop: {
      color: _pittaModules.LightColors.primary["3"],
      position: "absolute",
      left: 0
    },
    circleMiddle: {
      color: _pittaModules.LightColors.primary["0"],
      position: "absolute",
      left: 0,
      transform: "rotate(-93.25deg)!important"
    },
    boxDiv: {
      marginLeft: 12
    },
    data: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: 130
    }
  };
});
var DataUsage = function DataUsage(props) {
  var _t, _t2, _t3, _t4;
  var classes = useStyle();
  var t = props.t,
    plan = props.plan,
    used = props.used,
    chartWidth = props.chartWidth,
    bodyStyle = props.bodyStyle,
    availableStyle = props.availableStyle,
    usedStyle = props.usedStyle,
    availableDataStyle = props.availableDataStyle,
    usedDataStyle = props.usedDataStyle,
    planChartStyle = props.planChartStyle,
    usedChartStyle = props.usedChartStyle,
    usedBorderChartStyle = props.usedBorderChartStyle,
    dataDiv = props.dataDiv,
    availableDiv = props.availableDiv,
    usedDiv = props.usedDiv;

  // string 값으로 받아와서 number로 변환
  var planData = (0, _react.useMemo)(function () {
    if (plan) {
      return parseInt(plan.replace("GB", ""));
    } else {
      return undefined;
    }
  }, [plan]);

  // const totalData = plan * 1024;
  var totalData = (0, _react.useMemo)(function () {
    if (planData) {
      return planData * 1024;
    }
  }, [planData]);
  var usedData = used;
  // const availableData = totalData - usedData;
  var availableData = (0, _react.useMemo)(function () {
    if (totalData) {
      return totalData - usedData;
    } else {
      return 0;
    }
  }, [totalData, usedData]);

  // const AData = (totalData * 100) / totalData;
  var AData = (0, _react.useMemo)(function () {
    if (totalData) {
      return totalData * 100 / totalData;
    }
  }, [totalData]);

  // const UData = 100 - ((totalData - usedData) / totalData) * 100;
  var UData = (0, _react.useMemo)(function () {
    if (totalData) {
      return 100 - (totalData - usedData) / totalData * 100;
    }
  }, [totalData, usedData]);
  var round = (0, _react.useMemo)(function () {
    if (UData) {
      if (UData === 0) {
        return 0;
      } else if (UData === 100) {
        return 0;
      } else {
        return UData + 2;
      }
    }
  }, [UData]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.body, bodyStyle)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
    variant: "determinate"
    // value={plan === 0 ? 100 : AData}
    ,
    value: planData === undefined ? 100 : AData,
    className: (0, _clsx.default)(classes.circleBottom, planChartStyle),
    thickness: chartWidth
  }), /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
    variant: "determinate"
    // value={usedDataBorder()}
    // value={plan === 0 ? 0 : round()}
    ,
    value: planData === undefined ? 0 : round,
    className: (0, _clsx.default)(classes.circleMiddle, usedChartStyle),
    thickness: chartWidth
  }), /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
    variant: "determinate"
    // value={plan === 0 ? 0 : UData}
    ,
    value: planData === undefined ? 100 : UData,
    className: (0, _clsx.default)(classes.circleTop, usedBorderChartStyle),
    thickness: chartWidth
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.boxDiv, dataDiv)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.data, usedDiv)
  }, /*#__PURE__*/_react.default.createElement(_.Typography, {
    style: {
      color: _pittaModules.LightColors.primary["1"]
    },
    className: (0, _clsx.default)(usedStyle),
    category: "Default",
    variant: "Caption"
  }, (_t = t === null || t === void 0 ? void 0 : t("Used")) !== null && _t !== void 0 ? _t : "Used"), /*#__PURE__*/_react.default.createElement(_.Typography, {
    style: {
      color: _pittaModules.LightColors.primary["3"]
    },
    className: (0, _clsx.default)(usedDataStyle),
    category: "Default",
    variant: "BodyBold"
  }, planData === undefined ? 0 : Math.round(usedData), (_t2 = t === null || t === void 0 ? void 0 : t("MB")) !== null && _t2 !== void 0 ? _t2 : "MB")), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.data, availableDiv)
  }, /*#__PURE__*/_react.default.createElement(_.Typography, {
    style: {
      color: _pittaModules.LightColors.primary["1"]
    },
    className: (0, _clsx.default)(availableStyle),
    category: "Default",
    variant: "Caption"
  }, (_t3 = t === null || t === void 0 ? void 0 : t("Available")) !== null && _t3 !== void 0 ? _t3 : "Available"), /*#__PURE__*/_react.default.createElement(_.Typography, {
    style: {
      color: _pittaModules.LightColors.secondary["19"]
    },
    className: (0, _clsx.default)(availableDataStyle),
    category: "Default",
    variant: "BodyBold"
  }, planData === undefined ? 0 : Math.round(availableData), (_t4 = t === null || t === void 0 ? void 0 : t("MB")) !== null && _t4 !== void 0 ? _t4 : "MB"))));
};
exports.DataUsage = DataUsage;